function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.9487,21.5 C3.6827,21.5 3.4637,21.292 3.4497,21.026 L3.2107,16.5 L16.7887,16.5 L16.5507,21.026 C16.5367,21.292 16.3177,21.5 16.0517,21.5 L3.9487,21.5 Z",
  id: "Fill",
  fill: "#E6E6E6"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.3144,16 L3.6854,16 L3.0544,4 L16.9464,4 L16.3144,16 Z M3.9484,21 L3.7384,17 L16.2614,17 L16.0514,21 L3.9484,21 Z M8.0004,3 L12.0004,3 L12.0004,1 L8.0004,1 L8.0004,3 Z M19.5004,3 L13.0004,3 L13.0004,1 C13.0004,0.448 12.5524,0 12.0004,0 L8.0004,0 C7.4474,0 7.0004,0.448 7.0004,1 L7.0004,3 L0.5004,3 C0.2234,3 0.0004,3.224 0.0004,3.5 C0.0004,3.776 0.2234,4 0.5004,4 L2.0524,4 L2.9504,21.053 C2.9784,21.584 3.4164,22 3.9484,22 L16.0514,22 C16.5834,22 17.0224,21.584 17.0494,21.053 L17.3154,16 L17.9474,4 L19.5004,4 C19.7764,4 20.0004,3.776 20.0004,3.5 C20.0004,3.224 19.7764,3 19.5004,3 L19.5004,3 Z",
  id: "Outline",
  fill: "#CCCCCC"
});

var SvgTrash = function SvgTrash(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "20px",
    height: "22px",
    viewBox: "0 0 20 22",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTrash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trash.a262d86b.svg";
export { ForwardRef as ReactComponent };